import { PureComponent } from 'react';

import { FileInfo } from './FileInfo'
import { FileStyled } from './styles/FileStyled'
import { Media } from '../../elements/Media'
import { MediaWithViewer } from '../../elements/MediaWithViewer'

export interface IFileProps {
  /** The object of file data */
  data: IFileData
  /**
   * Shows the border around the component when `true`
   * @default true
   */
  border?: boolean
}

export interface IFileData {
  id?: string | number
  /** The URL path of the file */
  file?: string
  /** The URL path of the preview of the file. Can be Base64. */
  preview?: string
  /** Name of the file */
  name?: string
  /** Description of the file */
  description?: string
  /** Mimetype of the file */
  mimetype?: string
  /** Filesize of the file in bytes */
  length?: number
  /** Datetime info of the file */
  datetime?: Date
  /** Status text that gets displayed */
  status?: string
  /** Turns `status` text red when truthy */
  error?: string | boolean
  /** Any type of data that needs to be stored` */
  meta?: any
}

export class File extends PureComponent<IFileProps> {
  static defaultProps = {
    border: true,
  }

  render() {
    return (
      <FileStyled border={this.props.border}>
        <MediaWithViewer
          size='small'
          as='div'
          name={this.props.data.name}
          src={this.props.data.preview || this.props.data.file}
        />
        <FileInfo data={this.props.data} />
      </FileStyled>
    )
  }
}
